<template>
	<div class="circuit-container">
		<circuit-table :tableData="tableData" :totalCount="totalCount" downloadUrl="/dataModule/routeInfoDownload"></circuit-table>
	</div>
</template>

<script>
	import CircuitTable from './components/CircuitTable.vue'
	import {
		// fetchComList,
		fetchRouteList,
	} from '@/utils/api/com'
	// import {
	// 	fetchCancelConcern,
	// 	fetchAddConcern
	// } from '@/utils/api/concerned'
	export default {
		components: {
			CircuitTable,
		},
		data() {
			return {
				totalCount: 0,
				checkRows: [],
				tableData: [],
				multiButton: true
			}
		},
		mounted() {
			this.$store.dispatch('com/resetCircuitTableFilter')
		},
		computed: {
			filter() {
				return this.$store.getters.circuitTableFilter
			},
		},
		watch: {
			filter() {
				this.getRouteList()
			}
		},
		methods: {
			getRouteList() {
				this.$store.dispatch('com/setCircuitTableLoading', true)
				fetchRouteList(this.filter).then(({
					data
				}) => {
					this.tableData = data.datas
					this.totalCount = data.total
				}).finally(() => {
					this.$store.dispatch('com/setCircuitTableLoading', false)
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.circuit-container {
		height: 100%;
	}
</style>
